import React from 'react';
import { AiOutlineHome } from "react-icons/ai"
import { BsPercent, BsCart } from "react-icons/bs"

const MobileBottomNav = ({ setRight, right }) => {
    return (
        <div className='fixed bottom-0 left-0 w-full px-4 py-2 bg-black shadow-xl md:hidden block z_top'>
            <div className="flex justify-between ">
                <div className="flex flex-col justify-center items-center text-white font-semibold text-lg">
                    <AiOutlineHome className='text-4xl' />
                    <span>Home</span>
                </div>
                <div className="flex flex-col justify-center items-center text-white font-semibold text-lg">
                    <BsPercent className='text-4xl' />
                    <span>Offer</span>
                </div>
                <div onClick={() => setRight(!right)} className="flex flex-col justify-center items-center text-white font-semibold text-lg">
                    <BsCart className='text-4xl' />
                    <span>Cart</span>
                </div>
            </div>
        </div>
    );
};

export default MobileBottomNav;